var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-stream"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 32",
    d: "M12 3L4 9.5V21H20V10L12 3Z",
    fill: "url(#paint0_linear_744_783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.22531 9.42513V21.0681H19.7745V9.42513M1.63379 10.9924L11.9999 2.93188L22.366 10.9924",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_783",
    x1: 5.71429,
    y1: 3,
    x2: 21.8889,
    y2: 19.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDarkActive);
export default __webpack_public_path__ + "static/media/home-dark-active.d70ecfa78e9de4a4018f77458f920b4c.svg";
export { ForwardRef as ReactComponent };